module.exports = __webpack_public_path__ + "img/box_bg_11.4711ba08.png";